import * as Cookies from "js-cookie";

const getReferralCookie = () => {
  const cookieRaw = Cookies.get("lwReferralData");
  if (!cookieRaw) {
    return;
  }

  const cookieBaked = JSON.parse(cookieRaw);

  return cookieBaked;
};

const loadIr = () => {
  const cookiedata = getReferralCookie();
  const ircid = cookiedata?.ircid;

  // default to old tracker id
  let trackerId = process.env.VUE_APP_IMPACT_RADIUS_LEGACY_TRACKER_ID;
  let campaignId = process.env.VUE_APP_IMPACT_RADIUS_CAMPAIGN_ID;

  // if ircid is present on the ir cookie, replace campaign id with it, and use new tracker id
  if (ircid) {
    campaignId = ircid;
    trackerId = process.env.VUE_APP_IMPACT_RADIUS_TRACKER_ID;
  }

  (function (a, b, c, d, e, f, g) {
    e["ire_o"] = c;
    e[c] =
      e[c] ||
      function () {
        (e[c].a = e[c].a || []).push(arguments);
      };
    f = d.createElement(b);
    g = d.getElementsByTagName(b)[0];
    f.async = 1;
    f.src = a;
    g.parentNode.insertBefore(f, g);
  })(
    `https://d33wwcok8lortz.cloudfront.net/js/${campaignId}/${trackerId}/irv3.js`,
    "script",
    "ire",
    document,
    window
  );
};

if (process.env.VUE_APP_IMPACT_RADIUS_CAMPAIGN_ID) {
  loadIr();
}

const affiliates = {
  namespaced: true,
  state: {
    lwReferralCookie: getReferralCookie(),
  },
  mutations: {},
  actions: {
    conversion({ rootState }, { order }) {
      if (!process.env.VUE_APP_IMPACT_RADIUS_CAMPAIGN_ID || !getReferralCookie()) {
        return;
      }

      const lwReferralData = getReferralCookie();
      // Category purchased package, for example "Professional". Required
      const category = order?.service?.cloud_account?.app?.name || order.package.identity;
      // Unique product identifier
      const sku = order.package.label ? order.package.label.replace(/\./g, "_") : order.package_id;
      // Monthly cost of the package
      const mrr = Number(order.package.effective_monthly_fee["1"]);
      // The total sale amount for this line item. Required
      let total = order.total;

      // reset list of order items (otherwise the list of orders being fired will grow linearly each time, and send out duplicates)
      irEvent.items = [];

      if (order.discount) {
        // if there is a discount, still send the total without the discount applied.
        total = order.discount.amount + order.discount.total;
        // set promo code
        irEvent.setPromoCode(order.discount.code).setRebate(order.discount.amount);
      }

      if (
        !process.env.VUE_APP_IMPACT_RADIUS_ENABLE_ZERO_DOLLAR &&
        (Number(total) == 0 || utils.isFreeTrial({ package: order.package }))
      ) {
        return;
      }

      // app.execute('rollbar:affiliate', 'IR', {
      //   clickId: lwReferralData.clickid,
      //   lwReferralData,
      //   customerId: app.user.id,
      //   order,
      //   item: { category, sku, mrr }
      // });

      // required advertiser supplied values
      irEvent
        .setClickId(lwReferralData.clickid)
        .setCustomerId(rootState.auth.user.id)
        .setOrderId(order.id)
        .addItem(category, sku, mrr, 1);

      irEvent.fire();
    },
  },
  getters: {},
};

export default affiliates;
